export enum CampaignDiscountMethod {
    FromNormalPrice = 0,
    FromPriceList = 1
}

(CampaignDiscountMethod as any).__typeName = 'CampaignDiscountMethod';
